import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Unique second-hand devices (refurbished phones) are sold one-by-one at a
 * fixed price: they must never inherit site-wide promotions, model pickers or
 * skin add-on upsells.
 */
export function isRefurbishedProduct(
  tags?: string[] | null,
  productType?: string | null
): boolean {
  const haystack = [...(tags || []), productType || ""]
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);
  return haystack.some(
    (value) => value === "refurbished" || value === "reconditionné" || value.includes("refurbished")
  );
}
